(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecp"]) return;
  try {
    
//update the position of #ecp-cursor based on the mouse position on the page.
//if mouse hasn't been moved yet, or if mouse hasn't move for 5 seconds, hide the cursor
let ecpCursorTimeout;
let ecpCursor = document.getElementById("ecp-cursor");
addEventListener("mousemove", function(event) {
    ecpCursor.style.top = event.clientY + "px";
    ecpCursor.style.left = event.clientX + "px";
    clearTimeout(ecpCursorTimeout);
    ecpCursorTimeout = setTimeout(function() {
        ecpCursor.classList.remove("active");
    }, 5000);
});
let epcCursorText = document.getElementById("ecp-cursor-text");
let ecpPlusDivs = document.getElementById("ecp-cursor-plus").children;
//get all ecp-slides
let ecpSlides = document.getElementsByClassName("ecp-slide");
//when the mouse enters an ecp-slide, update the cursor color to match the ecp-slide color
for (let i = 0; i < ecpSlides.length; i++) {
    ecpSlides[i].addEventListener("mouseenter", function(event) {
        ecpCursor.classList.add("active"); 
        let color = event.target.getAttribute("ecp-color");
        //set ecpPlusDivs backgrounf to the ecp-slide color
        ecpPlusDivs[0].style.backgroundColor = color;
        ecpPlusDivs[1].style.backgroundColor = color;
        epcCursorText.style.color = color;
    });
    ecpSlides[i].addEventListener("mouseleave", function(event) {
        ecpCursor.classList.remove("active");
        setTimeout(function() {
            // ecpPlusDivs[0].style.backgroundColor = "white";
            // ecpPlusDivs[1].style.backgroundColor = "white";
            // epcCursorText.style.color = "white";
        }, 200);
    });
}

//if on mobile, detect actual height of screen and set #ecp to that height
let promoBarHeight = $("#promo-bar").height();

//to prevent on mobiles, but allow on small desktop screen, listen for touchstart and hide ecp-cursor
addEventListener("touchstart", function() {
    ecpCursor.classList.remove("active");
    ecpCursor.style.display = "none";
});

//if(window.innerWidth < 768) {
    //let ecp = document.getElementById("ecp");
    //ecp.style.height = window.innerHeight - promoBarHeight + "px";
//}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(productRecommendationsSection);
  
      const url = productRecommendationsSection.dataset.url;
  
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
  
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quicklinks"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        var collectionWrapper = document.querySelector('#product-grid');
        var quicklinks = document.querySelector('#quicklinks');
        collectionWrapper.insertBefore(quicklinks, collectionWrapper.firstChild);
        document.querySelector('#quicklinks').classList.add("ready");
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement"] && !Shopify.designMode) return;
  try {
    
let container;
function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

    var clientTop = docEl.clientTop || body.clientTop || 0;

    var top  = box.top +  scrollTop - clientTop;

    return Math.round(top);
}
function determineIfInView(){
  if(!container)
    container = document.querySelector("#statement-container");
  let offsetY = getCoords(container);
  let h = offsetY+container.clientHeight;
  let topVisible = window.scrollY<offsetY && window.scrollY+window.innerHeight > offsetY;
  let bottomVisible = window.scrollY<h && window.scrollY+window.innerHeight > h;
  return topVisible || bottomVisible;
}
document.addEventListener("DOMContentLoaded", function() {
  let freq = 10;
  let count = 0;
  let el = document.querySelector("#statement-container");
  let canvas = document.querySelector("#statement-canvas");
  canvas.setAttribute("width",window.innerWidth);
  canvas.setAttribute("height",window.innerHeight);
  let ctx = canvas.getContext("2d");
  let finished = []
  let imgShown = 0;
  let imgs = el.getAttribute("data-statement-images").split(",").forEach((img,i)=>{
    let image = new Image();
    let parts = img.split("~")
    let maxDimension = .3;
    let width = parseInt(parts[1]);
    let size = `&width=${Math.ceil((maxStatementImageDimension/100)*window.innerWidth/100)*100}`
    image.src = img+size;
    image.onload = () => {finished.push(image)}
  });
  if(window.innerWidth< 768){
    setInterval((e)=>{
      if(!determineIfInView()){
        return;
      }
      let img = finished[(imgShown++)%finished.length];
      ctx.drawImage(img,Math.floor(Math.random()*el.clientWidth)-(img.width/2), Math.floor(Math.random()*el.clientHeight)-(img.height/2))
    },750)
  }
  canvas.addEventListener('mousemove', e => {
    if(window.innerWidth< 768 || finished.length === 0 || (count++)%freq !== 0){
      return;
    }
    if(!ctx){
      ctx = canvas.getContext("2d");
    }
    let img = finished[(imgShown++)%finished.length];
    ctx.drawImage(img,e.offsetX-(img.width/2), e.offsetY-(img.height/2))
  });
});

  } catch(e) { console.error(e); }
})();
})();
